<template>
    <div class="nk-content nk-content-fluid">
        <div class="container-xl wide-lg">
            <div class="nk-content-body">
                <div class="nk-block-head nk-block-head-sm">
                    <div class="nk-block-between g-3">
                        <div class="nk-block-head-content">
                            <h3 class="nk-block-title page-title">Id History</h3>
                            <div class="nk-block-des text-soft">
                                <p>You have total {{rowCount}} Id.</p>
                            </div>
                        </div><!-- .nk-block-head-content -->
                        <div class="nk-block-head-content">
                            <input type="text" class="form-control" v-model="search" placeholder="Search..." />
                        </div>
                    </div><!-- .nk-block-between -->
                </div><!-- .nk-block-head -->

                <div class="nk-block nk-block-lg">
                    <div class="row g-gs">
                        <div class="col-md-6 col-lg-4" v-for="(details) in userList" v-bind:key="details.id">
                            <div class="card card-bordered">
                                <div class="nk-wgw">
                                    <div class="nk-wgw-inner">
                                        <a class="nk-wgw-name" href="javascript:void(0)">                                            
                                            <h5 class="nk-wgw-title title">{{details.subUserCode}} </h5>
                                            <h5 class="nk-wgw-title title">
                                                <span v-if="details.approval==1" class="badge  bg-success"> Approved</span>
                                                <span v-if="details.approval==5" class="badge  bg-warning"> Expired</span>
                                                <span v-if="details.approval==2" class="badge  bg-info"> Processing</span>
                                                <span v-if="details.approval==3" class="badge  bg-danger"> Rejected</span>
                                            </h5>
                                            
                                        </a>
                                        <div class="nk-wgw-balance">
                                            <div class="amount">${{details.amount}}</div>
                                            <div class="amount-sm">${{AmountFormat(details.roiProfitAmount)}} <span class="currency currency-usd">ROI Amount</span></div>
                                        </div>
                                    </div>
                                    <div class="nk-wgw-actions">
                                        <ul>
                                            <li><a href="javascript:void(0)"> {{parseFloat(details.roiProfitAmount/details.amount * 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}}% <em class="icon ni ni-arrow-long-up"></em> <span>Profit</span></a></li>
                                            <li><a href="javascript:void(0)"> {{getDate(details.date)}}</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div><!-- .card -->
                        </div><!-- .col -->
                        <div class="col-md-6 col-lg-4">
                            <div class="card card-bordered dashed h-100">
                                <div class="nk-wgw-add">
                                    <div class="nk-wgw-inner">
                                        <a href="/CreateNewId">
                                            <div class="add-icon">
                                                <em class="icon ni ni-plus"></em>
                                            </div>
                                            <h6 class="title">Add New Id</h6>
                                        </a>
                                        <span class="sub-text">You can create your new Id.</span>
                                    </div>
                                </div>
                            </div><!-- .card -->
                        </div><!-- .col -->
                    </div><!-- .row -->
                </div><!-- .nk-block -->


                <div class="nk-block">
                    <div class="card card-bordered card-stretch">
                        <div class="card-inner-group">

                            <div class="card-inner">
                                <div class="nk-block-between-md g-3">
                                    <div class="g">
                                        <div class="pagination justify-content-center justify-content-md-start">
                                            <div class="overflow-auto" v-on:click="getPage()">
                                                <b-pagination pills size="md" v-model="currentPage"
                                                              :total-rows="rowCount"
                                                              :per-page="10"
                                                              first-text="First"
                                                              prev-text="Previous"
                                                              next-text="Next"
                                                              last-text="Last"></b-pagination>
                                            </div>
                                        </div><!-- .pagination -->
                                    </div>
                                    <div class="g">
                                        <div class="pagination-goto d-flex justify-content-center justify-content-md-start gx-3 text-capitalize">
                                            <span v-if="currentPage===1 && rowCount === 0"> Showing 0 to 0 of 0 entries</span>
                                            <span v-else-if="currentPage===1 && rowCount < 10"> Showing {{currentPage}} to {{rowCount}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage===1 && rowCount >= 11  "> Showing {{currentPage}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage===1"> Showing {{currentPage}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage!==1 && currentPage!==pageCount"> Showing {{(currentPage*10)-9}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage === pageCount"> Showing {{(currentPage*10)-9}} to {{rowCount}} of {{rowCount}} entries</span>
                                        </div>
                                    </div><!-- .pagination-goto -->
                                </div><!-- .nk-block-between -->
                            </div><!-- .card-inner -->
                        </div><!-- .card-inner-group -->
                    </div><!-- .card -->
                </div><!-- .nk-block -->
            </div>
        </div>
    </div>

</template>
<script>
    import moment from "moment";
    export default {
        name: 'PackagePriceList',
        data: function () {
            return {
                search: '',
                currentPage: 1,
                pageCount: '',
                rowCount: '',
                pageSize: '',
                isDesc: false,

                loading: false,
                userList: [],

            }
        },
        watch: {
            search: function (val) {
                this.GetData(val, 1);
            }
        },
        methods: {
            getDate: function (date) {
                return moment(date).format('D-MM-YYYY HH:mm');
            },

            AmountFormat: function (amount) {
                return parseFloat(amount).toFixed(4);
            },

            AddSignup: function () {
                this.$router.push('/AddPackagePrice')
            },

            getPageSize: function (isDesc) {
                this.isDesc = isDesc;
                this.getPage();
            },

            getPage: function () {
                this.GetData(this.search, this.currentPage);
            },

            GetData: function (search, currentPage) {
                var root = this;
                var url = '/Report/MyIdHistory?searchTerm=' + search + '&pageNumber=' + currentPage + '&isDesc=' + this.isDesc;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get(url, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        root.userList = response.data.results;
                        root.pageCount = response.data.pageCount;
                        root.rowCount = response.data.rowCount;
                    }
                }).catch(error => {
                    console.log(error)
                    root.$swal.fire({
                        icon: 'error',
                        type: 'error',
                        title: 'Error',
                        text: "Something Went Wrong",
                        showConfirmButton: false,
                        timer: 5000,
                        timerProgressBar: true,
                    });
                }).finally(() => root.loading = false);
            },


        },
        created: function () {
        },
        mounted: function () {
            this.GetData(this.search, 1);
        },
    }
</script>